export const MODAL_TYPES = {
  VERIFY: 'VERIFY',
  VALID: 'VALID',
  INVALID: 'INVALID',
  ACCESS_ESTABLISHED: 'ACCESS_ESTABLISHED',
  FAILED_ACCESS: 'FAILED_ACCESS',
};

export const VERIFICATION_TYPES = [
  {
    type: 'AADHAAR',
    icon: 'Aadhaar',
    text: 'Aadhaar',
  },
  {
    type: 'PAN',
    icon: 'Pan',
    text: 'Pan',
  },
  {
    type: 'DRIVING_LICENSE',
    icon: 'DL',
    text: 'Driving License',
  },
];
